/**
 * Sidebar Information Management
 * Gère l'ouverture et fermeture des sidebars avec animations
 */

class SidebarInformation {
  constructor() {
    this.activeSidebar = null
    this.isAnimating = false
    this.init()
  }

  init() {
    // Écouter les clics sur les éléments déclencheurs
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-reinsurance-sidebar]')
      if (trigger) {
        e.preventDefault()
        this.openSidebar(trigger.dataset.reinsuranceSidebar)
      }

      // Écouter les clics sur le background pour fermer
      const close = e.target.closest('[data-reinsurance-sidebar-close]')
      if (close && this.activeSidebar) {
        e.preventDefault()
        this.closeSidebar()
      }
    })

    // Fermer avec la touche Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeSidebar) {
        this.closeSidebar()
      }
    })
  }

  openSidebar(sidebarId) {
    if (this.isAnimating) return

    const sidebar = document.querySelector(
      `[data-reinsurance-sidebar-content="${sidebarId}"]`
    )
    if (!sidebar) return

    this.isAnimating = true
    this.activeSidebar = sidebarId
    // Mémoriser l'élément déclencheur pour restaurer le focus à la fermeture.
    this.lastFocusedElement = document.activeElement

    document
      .querySelectorAll('[data-reinsurance-sidebar]')
      .forEach((trigger) => {
        const isOpen = trigger.dataset.reinsuranceSidebar === sidebarId
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
      })

    // Déplacer le sidebar à la fin du body pour éviter les problèmes de z-index
    if (sidebar.parentNode !== document.body) {
      document.body.appendChild(sidebar)
    }

    document.body.classList.add('is-overflow-hidden')

    // Ajouter la classe active pour afficher le background
    sidebar.classList.add('active')

    // Déplacer le focus dans la sidebar (bouton de fermeture en priorité).
    const closeButton = sidebar.querySelector('[data-reinsurance-sidebar-close]')
    if (closeButton && closeButton.focus) {
      closeButton.focus()
    }

    // Attendre un peu pour que le background s'affiche, puis animer la sidebar
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const sidebarContent = sidebar.querySelector(
          '.reinsurances-custom__sidebar-content'
        )
        if (sidebarContent) {
          sidebarContent.classList.add('active')
        }
      })
    })

    // Réinitialiser l'état d'animation après l'animation
    setTimeout(() => {
      this.isAnimating = false
    }, 400)
  }

  closeSidebar() {
    if (this.isAnimating || !this.activeSidebar) return

    this.isAnimating = true
    const sidebar = document.querySelector(
      `[data-reinsurance-sidebar-content="${this.activeSidebar}"]`
    )

    if (!sidebar) {
      this.isAnimating = false
      return
    }

    const sidebarContent = sidebar.querySelector(
      '.reinsurances-custom__sidebar-content'
    )

    // Animer la fermeture de la sidebar
    if (sidebarContent) {
      sidebarContent.classList.remove('active')

      document.body.classList.remove('is-overflow-hidden')
    }

    // Attendre la fin de l'animation de la sidebar, puis retirer le background
    sidebar.classList.remove('active')
    this.activeSidebar = null
    this.isAnimating = false

    document
      .querySelectorAll('[data-reinsurance-sidebar]')
      .forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false')
      })

    // Restaurer le focus sur l'élément déclencheur.
    if (this.lastFocusedElement && this.lastFocusedElement.focus) {
      this.lastFocusedElement.focus()
      this.lastFocusedElement = null
    }
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new SidebarInformation()
})

// Initialiser aussi si le script est chargé après le DOM
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     new SidebarInformation()
//   })
// } else {
//   new SidebarInformation()
// }
